import { Video } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * The product lockup. Deliberately quiet in-call — the candidate should be
 * looking at the interviewer, not at our logo — and larger on the pages where
 * it is the only thing establishing who is asking for camera access.
 */
export function BrandMark({
  size = 'md',
  showWordmark = true,
  className,
}: {
  size?: 'sm' | 'md' | 'lg';
  showWordmark?: boolean;
  className?: string;
}) {
  const box = { sm: 'size-7 rounded-lg', md: 'size-9 rounded-xl', lg: 'size-12 rounded-2xl' }[size];
  const icon = { sm: 'size-3.5', md: 'size-4.5', lg: 'size-6' }[size];
  const word = { sm: 'text-sm', md: 'text-base', lg: 'text-lg' }[size];

  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <span
        className={cn(
          'from-primary grid place-items-center bg-linear-to-br to-[oklch(0.55_0.18_215)] shadow-[0_8px_20px_-8px_var(--primary)]',
          box,
        )}
      >
        <Video className={cn('text-white', icon)} strokeWidth={2.25} />
      </span>
      {showWordmark && (
        <span className={cn('leading-none font-semibold tracking-tight', word)}>
          Hiredude <span className="text-muted-foreground font-normal">Meet</span>
        </span>
      )}
    </div>
  );
}
